import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Colors from '../colors';

export default function ButtonAppBar({ toggleDrawer }) {
  const PAGE_NAMES = [
    { page: '/', text: 'Dashboard' },
    { page: '/tailgate-forms', text: 'Tailgate Forms' },
    { page: '/forms', text: 'Edit Tailgate Form' },
    { page: '/teams', text: 'Teams' },
    { page: '/createTeam', text: 'Teams' },
    { page: '/contacts', text: 'Contacts' },
    { page: '/login', text: 'Log in' },
    { page: '/signup', text: 'Sign up' },
    { page: '/forgot-password', text: 'Reset Password' },
    { page: '/attendance', text: 'Attendance' },
    { page: '/safety-audits', text: 'Safety Audits' },
    { page: '/spot-checks', text: 'Edit Safety Audit' },
    { page: '/account', text: 'Account' },
    { page: '/locations', text: 'Locations' },
    { page: '/admins', text: 'Update Permissions' },
    { page: '/incidents', text: 'Edit Incident' },
  ];


  function extractString(str) {
    const regex = /^\/[^/]+/;
    const match = str.match(regex);
    if (match !== null) return match[0];
    return str;
  }

  const location = useLocation();
  let pathName = location.pathname;
  pathName = extractString(pathName);
  const nameOfPage = PAGE_NAMES.find(el => el.page === pathName)?.text;
  const isLoginPage = pathName === '/login' || pathName === '/signup' || pathName === '/forgot-password';
  const isRoot = pathName === '/' || location.pathname === '/login';

  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="fixed"
          sx={{
            bgcolor: Colors.green,
            borderBottomLeftRadius: 5,
            borderBottomRightRadius: 5,
            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)'
          }} >
          <Toolbar>
            {!isRoot && <IconButton
              color="inherit"
              onClick={goBack} >
              <ArrowBackIosNewIcon />
            </IconButton>}
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontFamily: 'Jost',
                fontSize: '1.4rem',
                flexGrow: 1,
                textAlign: isRoot ? 'left' : 'center'
              }}>
              {nameOfPage}
            </Typography>
            {!isLoginPage && <IconButton
              size="2%"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer} >
              <MenuIcon
                sx={{ fontSize: '135%' }} />
            </IconButton>}
          </Toolbar>
        </AppBar>
      </Box>
      <Outlet />
    </div>
  );
}